/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { Component, OnInit, ChangeDetectionStrategy, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-layout-signalr-dialog',
  templateUrl: './layout-signalr-dialog.component.html',
  styleUrls: ['./layout-signalr-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutSignalRDialogComponent implements OnInit {
  reconnectClicked = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<LayoutSignalRDialogComponent>
  ) { }

  ngOnInit() { }

  reconnect() {
    this.reconnectClicked.emit();
  }
}
